import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppointmentStatusGridComponent } from './appointment-status-grid.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppointmentStatusGridEffects } from './state/appointment-status-grid.effects';
import { appointmentStatusGridReducer } from './state/appointment-status-grid.reducer';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [AppointmentStatusGridComponent],
  imports: [
    CommonModule,
    GridModule,
    DialogModule,
    SharedModule,
    FormsModule,
    StoreModule.forFeature('appointmentStatusGrid', appointmentStatusGridReducer),
    EffectsModule.forFeature([AppointmentStatusGridEffects]),
    TranslateModule
  ],
  exports: [  
    AppointmentStatusGridComponent,
    TranslateModule 
  ]
})
export class AppointmentStatusGridModule { }
